import { Col, Row } from "react-bootstrap"
import Header from "../Header"
import { CardContent, CardMedia, Divider } from "@mui/material"
import { url_images } from "../../lib/backend/data"
import Card from '@mui/material/Card';
import NewletterSite from "../Home/newsletter";
import SocialIcons from "../Home/socialMedia";
import FooterText from "../Home/footerText";
import { estilo_last_mile } from "../../lib/global/styles";

const Business = () => {

    const footer = () =>{
        const newsletter = <NewletterSite />
      const social = <SocialIcons zone="social_media_footer" />
      const footer_text = <FooterText />
      if(!newsletter && !social && !footer_text) return false

      return <footer>
          <div className='p-4 bg-white'>
            <Row className='justify-content-md-center'>
            {newsletter ? <Col md={8} xs={12}>{newsletter}</Col> : false }
            {social ? <Col md={3} xs={12}>{social}</Col> : false }
            </Row>
            {footer_text ? <div className='mt-3'>{footer_text}</div> : false }
        </div>
      </footer>
    }
    return <div>
        <Header />
        <div className="p-4 container">
            <h1 className="bold" style={{ color: estilo_last_mile.color_secondary }}>Somos Andino</h1>
            {/* <h4>Somos Andino una chocolatería consciente, con valores acentuados de respeto, compañerismo, apoyo mutuo y actitud de aprendizaje</h4> */}
            <Divider sx={{ mb:2, mt:2 }} />
            <h4>Regalos Corporativos con Sabor y Estilo</h4>
            <p>¡Deliciosos regalos Venta Empresa!</p>
            <p>Ofrecemos un servicio completo y personalizado para tu empresa y tus necesidades</p>
            <h5>¿Qué ofrecemos?</h5>
            <ul>
                <li>Packaging corporativo a medida</li>
                <li>Productos de alta calidad y sabor excepcional</li>
                <li>Despacho puntual y atención personalizada</li>
            </ul>
            <h5>Con años de experiencia creando regalos premium, nuestro equipo te acompaña en cada paso para entregar una experiencia inolvidable.</h5>
            <a href="mailto:contacto@chocolateandino.cl" >Escríbenos a contacto@chocolateandino.cl</a>
        </div>
    {footer()}
    </div>
}

export default Business